
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref920"];
var parcelRegister = parcelRequire.register;
parcelRegister("7vY2N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $578a012de88ccea7$export$2e2bcd8739ae039; });

var $9Ecwd = parcelRequire("9Ecwd");

var $2eRSM = parcelRequire("2eRSM");

var $2J5Gv = parcelRequire("2J5Gv");

var $g8m6m = parcelRequire("g8m6m");

var $bs6hr = parcelRequire("bs6hr");

var $2EE0j = parcelRequire("2EE0j");

var $2TVum = parcelRequire("2TVum");
function $578a012de88ccea7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $578a012de88ccea7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $578a012de88ccea7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $578a012de88ccea7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $578a012de88ccea7$var$getParentStack(labelStack) {
    if (!labelStack || labelStack.length <= 1) return null;
    return labelStack.slice(0, labelStack.length - 1);
}
function $578a012de88ccea7$var$getSegmentId(labelStack) {
    if (!labelStack) return null;
    var leafLabelStack = labelStack[labelStack.length - 1];
    if ((0, $2EE0j.isSegmentLabel)(leafLabelStack)) return leafLabelStack.segmentId;
    var parentStack = $578a012de88ccea7$var$getParentStack(labelStack);
    if (!parentStack) return null;
    return $578a012de88ccea7$var$getSegmentId(parentStack);
}
function $578a012de88ccea7$var$getParentSegmentId(labelStack) {
    return $578a012de88ccea7$var$getSegmentId($578a012de88ccea7$var$getParentStack(labelStack));
}
/**
 * Whenever a render happen, all parent segment have timing reported
 * This method tries to reduce that noise
 */ function $578a012de88ccea7$var$removeCascadingParentTimingReport(reactProfilerTimings) {
    var timingIndex = new Map();
    reactProfilerTimings.forEach(function(timing) {
        var segmentId = $578a012de88ccea7$var$getSegmentId(timing.labelStack);
        if (segmentId) {
            var _timingIndex$get;
            var timingArray = (_timingIndex$get = timingIndex.get(segmentId)) !== null && _timingIndex$get !== void 0 ? _timingIndex$get : [];
            timingIndex.set(segmentId, timingArray);
            timingArray.push(timing);
        }
    });
    reactProfilerTimings.forEach(function(timing) {
        var parentSegmentId = $578a012de88ccea7$var$getParentSegmentId(timing.labelStack);
        if (parentSegmentId) {
            var parentTimings = timingIndex.get(parentSegmentId);
            var filteredParentTimings = parentTimings === null || parentTimings === void 0 ? void 0 : parentTimings.filter(function(parentTiming) {
                return !(parentTiming.startTime === timing.startTime && parentTiming.actualDuration === timing.actualDuration);
            });
            if (filteredParentTimings) timingIndex.set(parentSegmentId, filteredParentTimings);
            else timingIndex.delete(parentSegmentId);
        }
    });
    return (0, $2eRSM.default)(timingIndex.values()).flatMap(function(v) {
        return v;
    });
}
function $578a012de88ccea7$var$transformReactProfilerTimings(reactProfilerTimings) {
    var filtered = $578a012de88ccea7$var$removeCascadingParentTimingReport(reactProfilerTimings !== null && reactProfilerTimings !== void 0 ? reactProfilerTimings : []);
    var reactProfilerTimingsMap = filtered.reduce(function(result, _ref) {
        var labelStack = _ref.labelStack, startTime = _ref.startTime, commitTime = _ref.commitTime, actualDuration = _ref.actualDuration, type = _ref.type;
        if (labelStack && type !== "nested-update") {
            var label = labelStack.map(function(ls) {
                return ls.name;
            }).join("/");
            var start = Math.round(startTime);
            var end = Math.round(commitTime);
            var timing = result.get(label) || {
                labelStack: label,
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 1,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = Math.round(start);
            if (end > timing.endTime) timing.endTime = Math.round(end);
            if (type === "mount") timing.mountCount += 1;
            if (type === "update") timing.rerenderCount += 1;
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return (0, $2eRSM.default)(reactProfilerTimingsMap.values());
}
function $578a012de88ccea7$export$2e2bcd8739ae039(_ref2) {
    var _window$location;
    var lastInteractionFinish = _ref2.lastInteractionFinish, reactProfilerTimings = _ref2.reactProfilerTimings, lastInteractionFinishVCResult = _ref2.lastInteractionFinishVCResult, postInteractionFinishVCResult = _ref2.postInteractionFinishVCResult;
    var config = (0, $bs6hr.getConfig)();
    if (!config) throw Error("UFO Configuration not provided");
    var ufoName = (0, $2EE0j.sanitizeUfoName)(lastInteractionFinish.ufoName);
    var rate = (0, $bs6hr.getPostInteractionRate)(ufoName, lastInteractionFinish.type);
    if (!(0, $2J5Gv.default)(rate)) return null;
    var pageVisibilityState = (0, $2TVum.getPageVisibilityState)(lastInteractionFinish.start, lastInteractionFinish.end);
    if (pageVisibilityState !== "visible") return null;
    var maxEndTimeFromProfiler = reactProfilerTimings ? Math.max.apply(Math, (0, $2eRSM.default)(reactProfilerTimings.map(function(t) {
        return t.commitTime;
    }))) : lastInteractionFinish.end;
    var revisedEndTime = Math.round(maxEndTimeFromProfiler);
    var revisedTtai = Math.round(maxEndTimeFromProfiler - lastInteractionFinish.start);
    var lastInteractionFinishStart = Math.round(lastInteractionFinish.start);
    var lastInteractionFinishEnd = Math.round(lastInteractionFinish.end);
    var lastInteractionFinishTTAI = Math.round(lastInteractionFinish.end - lastInteractionFinish.start);
    var lastInteractionFinishVC90 = null;
    var lastInteractionFinishVCClean = false;
    if (lastInteractionFinishVCResult !== null && lastInteractionFinishVCResult !== void 0 && lastInteractionFinishVCResult["ufo:vc:state"]) {
        var _lastInteractionFinis;
        lastInteractionFinishVCClean = true;
        var lastInteractionFinishVCMetrics = lastInteractionFinishVCResult === null || lastInteractionFinishVCResult === void 0 ? void 0 : lastInteractionFinishVCResult["metrics:vc"];
        lastInteractionFinishVC90 = (_lastInteractionFinis = lastInteractionFinishVCMetrics[90]) !== null && _lastInteractionFinis !== void 0 ? _lastInteractionFinis : null;
    }
    var postInteractionFinishVCRatios = {};
    var revisedVC90 = null;
    var postInteractionFinishVCUpdates = [];
    var postInteractionFinishVCClean = false;
    if (postInteractionFinishVCResult !== null && postInteractionFinishVCResult !== void 0 && postInteractionFinishVCResult["ufo:vc:state"]) {
        postInteractionFinishVCClean = true;
        postInteractionFinishVCRatios = postInteractionFinishVCResult === null || postInteractionFinishVCResult === void 0 ? void 0 : postInteractionFinishVCResult["ufo:vc:ratios"];
        postInteractionFinishVCUpdates = postInteractionFinishVCResult === null || postInteractionFinishVCResult === void 0 ? void 0 : postInteractionFinishVCResult["ufo:vc:updates"];
        var postInteractionFinishVCMetrics = postInteractionFinishVCResult === null || postInteractionFinishVCResult === void 0 ? void 0 : postInteractionFinishVCResult["metrics:vc"];
        if (typeof lastInteractionFinishVC90 === "number") {
            var _postInteractionFinis;
            revisedVC90 = (_postInteractionFinis = postInteractionFinishVCMetrics[90]) !== null && _postInteractionFinis !== void 0 ? _postInteractionFinis : null;
        }
    }
    var lateMutations = postInteractionFinishVCUpdates.filter(function(entry) {
        return entry.time > lastInteractionFinish.end;
    }).flatMap(function(_ref3) {
        var time = _ref3.time, elements = _ref3.elements;
        return Array.from(new Set(elements)).map(function(element) {
            return {
                time: time,
                element: element,
                viewportHeatmapPercentage: postInteractionFinishVCRatios[element]
            };
        });
    });
    return {
        actionSubject: "experience",
        action: "measured",
        eventType: "operational",
        source: "measured",
        tags: [
            "observability"
        ],
        attributes: {
            properties: {
                // basic
                "event:hostname": ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || "unknown",
                "event:product": config.product,
                "event:schema": "1.0.0",
                "event:source": {
                    name: "react-ufo/web",
                    version: (0, $g8m6m.REACT_UFO_VERSION),
                    payloadSource: "platform"
                },
                "event:region": config.region || "unknown",
                "experience:key": "custom.post-interaction-logs",
                postInteractionLog: {
                    lastInteractionFinish: $578a012de88ccea7$var$_objectSpread($578a012de88ccea7$var$_objectSpread({}, lastInteractionFinish), {}, {
                        ufoName: ufoName,
                        start: lastInteractionFinishStart,
                        end: lastInteractionFinishEnd,
                        ttai: lastInteractionFinishTTAI,
                        vc90: lastInteractionFinishVC90,
                        vcClean: lastInteractionFinishVCClean
                    }),
                    revisedEndTime: revisedEndTime,
                    revisedTtai: revisedTtai,
                    revisedVC90: revisedVC90,
                    vcClean: postInteractionFinishVCClean,
                    lateMutations: lateMutations,
                    reactProfilerTimings: $578a012de88ccea7$var$transformReactProfilerTimings(reactProfilerTimings)
                }
            }
        }
    };
}

});
parcelRegister("g8m6m", function(module, exports) {

$parcel$export(module.exports, "REACT_UFO_VERSION", function () { return $bbee899f7342ed67$export$4cbfa0cbc1d9a512; });

var $jxLBU = parcelRequire("jxLBU");
var $bbee899f7342ed67$export$4cbfa0cbc1d9a512 = (0, $jxLBU.fg)("enable-react-ufo-payload-segment-compressed") ? "2.0.0" : "1.0.1";

});

parcelRegister("2EE0j", function(module, exports) {

$parcel$export(module.exports, "sanitizeUfoName", function () { return $1eee592e840d423e$export$e08487ea3ae92adb; });
$parcel$export(module.exports, "isSegmentLabel", function () { return $1eee592e840d423e$export$1adbaf5c2363e4ae; });
$parcel$export(module.exports, "buildSegmentTree", function () { return $1eee592e840d423e$export$1569bc0edeecbcd8; });
$parcel$export(module.exports, "stringifyLabelStackFully", function () { return $1eee592e840d423e$export$caeee352b541de1f; });
$parcel$export(module.exports, "labelStackStartWith", function () { return $1eee592e840d423e$export$1787b1cd413c7e2; });
$parcel$export(module.exports, "optimizeLabelStack", function () { return $1eee592e840d423e$export$a0cd72da07c76b4c; });

var $9Ecwd = parcelRequire("9Ecwd");

var $g8m6m = parcelRequire("g8m6m");
function $1eee592e840d423e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1eee592e840d423e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1eee592e840d423e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1eee592e840d423e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1eee592e840d423e$export$e08487ea3ae92adb = function sanitizeUfoName(name) {
    return name.replace(/_/g, "-");
};
function $1eee592e840d423e$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === "string" && typeof obj.segmentId === "string";
}
function $1eee592e840d423e$export$1569bc0edeecbcd8(labelStacks) {
    var r = {
        n: "segment-tree-root",
        c: {}
    };
    labelStacks.forEach(function(labelStack) {
        var currentNode = r;
        labelStack.forEach(function(label) {
            var name = label.name;
            var id = $1eee592e840d423e$export$1adbaf5c2363e4ae(label) ? label.segmentId : undefined;
            var key = id !== undefined ? id : name;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name
            };
            currentNode = currentNode.c[key];
        });
    });
    return {
        r: r
    };
}
function $1eee592e840d423e$export$caeee352b541de1f(labelStack) {
    return labelStack.map(function(l) {
        if ($1eee592e840d423e$export$1adbaf5c2363e4ae(l)) return "".concat(l.name, ":").concat(l.segmentId);
        return l.name;
    }).join("/");
}
function $1eee592e840d423e$var$getLabelStackReference(labelStack) {
    return labelStack.map(function(l) {
        return $1eee592e840d423e$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name;
    }).join("/");
}
function $1eee592e840d423e$export$1787b1cd413c7e2(labelStack, startWith) {
    return $1eee592e840d423e$export$caeee352b541de1f(labelStack).startsWith($1eee592e840d423e$export$caeee352b541de1f(startWith));
}
function $1eee592e840d423e$export$a0cd72da07c76b4c(labelStack) {
    return (0, $g8m6m.REACT_UFO_VERSION) === "2.0.0" ? $1eee592e840d423e$var$getLabelStackReference(labelStack) : labelStack.map(function(ls) {
        return $1eee592e840d423e$var$_objectSpread({
            n: ls.name
        }, ls.segmentId ? {
            s: ls.segmentId
        } : {});
    });
}

});



//# sourceMappingURL=create-post-interaction-log-payload.386eabe5.js.map
